export default {
  namespaced: true,
  state: {
    searchTargetGroups: [],
    reachHeaders: [],
    siteSearchTargetGroups: [],
    siteReachTargetGroups: [],
    campaignTargetGroups: [],
    campaignReachTargetGroups: []
  },
  getters: {
    searchTargetGroups: state => state.searchTargetGroups,
    reachHeaders: state => state.reachHeaders,
    siteSearchTargetGroups: state => state.siteSearchTargetGroups,
    siteReachTargetGroups: state => state.siteReachTargetGroups,
    campaignTargetGroups: state => state.campaignTargetGroups,
    campaignReachTargetGroups: state => state.campaignReachTargetGroups,
  },
  mutations: {
    defineSearchTargetGroups(state, newSearchTargetGroups) {
      state.searchTargetGroups = newSearchTargetGroups;
    },
    defineReachHeaders(state, newReachTargetGroups) {
      state.reachHeaders = newReachTargetGroups;
    },
    defineSiteSearchTargetGroups(state, newSiteSearchTargetGroups) {
      state.siteSearchTargetGroups = newSiteSearchTargetGroups;
    },
    defineSiteReachTargetGroups(state, newSiteReachTargetGroups) {
      state.siteReachTargetGroups = newSiteReachTargetGroups;
    },
    defineCampaignTargetGroups(state, newCampaignTargetGroups) {
      state.campaignTargetGroups = newCampaignTargetGroups;
    },
    defineCampaignReachTargetGroups(state, newCampaignReachTargetGroups) {
      state.campaignReachTargetGroups = newCampaignReachTargetGroups;
    }
  }
};
